import { apiClient } from "../Config/ApiClient";

export const retrieveStockSession = (token) =>
  apiClient.get(`/stock/special`, { headers: { Authorization: token } });

export const retrieveStockOpening = (type, icode, currency, token) =>
  apiClient.get(`/stock/opening`, {
    params: { type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveStockData = (type, icode, currency, token) =>
  apiClient.get(`/stock/data`, {
    params: { type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveExecution = (type, icode, currency, token) =>
  apiClient.get(`/stock/execution`, {
    params: { type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveMatch = (type, icode) =>
  apiClient.get(`/stock/match`, { params: { type: type, icode: icode } });

export const retrieveClosing = (type, icode, currency, token) =>
  apiClient.get(`/stock/closing`, {
    params: { type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveAfterClosing = (type, icode, currency, token) =>
  apiClient.get(`/stock/after`, {
    params: { type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveRecentTrades = (type, icode, currency, token) =>
  apiClient.get(`/stock/recenttrade`, {
    params: { type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveStockInfo = (type, icode, token) =>
  apiClient.get(`/stock/issue-info`, {
    params: { type: type, icode: icode },
    headers: { Authorization: token },
  });

export const retrieveStockHistoryPrice = (
  type,
  icode,
  start_date,
  end_date,
  token
) =>
  apiClient.get("/stock/price-history", {
    params: {
      m_type: type,
      icode: icode,
      start_date: start_date,
      end_date: end_date,
    },
    headers: { Authorization: token },
  });

export const retrieveStockInfomation = (type, icode, token) =>
  apiClient.get(`/stock/info`, {
    params: { m_type: type, icode: icode },
    headers: { Authorization: token },
  });

export const retrieveStockDividend = (type, icode, token) =>
  apiClient.get(`/stock/dividend`, {
    params: { m_type: type, icode: icode },
    headers: { Authorization: token },
  });

export const retrieveStockScreen1 = (lang, icode, token) =>
  apiClient.get(`/stock/screen1`, {
    params: { lang: lang, icode: icode },
    headers: { Authorization: token },
  });

export const retrieveStockScreen1Data = (type, icode, currency, token) =>
  apiClient.get(`/stock/screen1/data`, {
    params: { m_type: type, icode: icode, currency: currency },
    headers: { Authorization: token },
  });

export const retrieveStockCurrentPrice = (token) =>
  apiClient.get(`/stock/current-price`, { headers: { Authorization: token } });

export const retrieveStockScreen2 = (params, token) =>
  apiClient.get(`/stock/screen2`, {
    params: params,
    headers: { Authorization: token },
  });

export const retrieveStockScreen2Data = (params, token) =>
  apiClient.get(`/stock/screen2/data`, {
    params: params,
    headers: { Authorization: token },
  });

export const retrieveStockScreen3 = (type, token) =>
  apiClient.get(`/stock/screen3`, {
    params: { m_type: type },
    headers: { Authorization: token },
  });

export const retrieveStockScreen3Data = (type, token) =>
  apiClient.get(`/stock/screen3/data`, {
    params: { m_type: type },
    headers: { Authorization: token },
  });

export const retrieveStockAll = (token) =>
  apiClient.get(`/stock/get-all-stock`, { headers: { Authorization: token } });
